import { render, staticRenderFns } from "./riskkayitformu.vue?vue&type=template&id=baf9b1b8"
import script from "./riskkayitformu.vue?vue&type=script&lang=js"
export * from "./riskkayitformu.vue?vue&type=script&lang=js"
import style0 from "./riskkayitformu.vue?vue&type=style&index=0&id=baf9b1b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports